import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { GettingStartedPage } from "@javascript/components/developer-docs/GettingStartedPage"

interface GettingStartedContent {
  pages: DeveloperDocsPage[]
  themeJsonExample: string
  templateLiquidExample: string
}

export default function GettingStarted() {
  const { pages, themeJsonExample, templateLiquidExample } = useContent<GettingStartedContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/getting-started">
      <GettingStartedPage
        themeJsonExample={themeJsonExample}
        templateLiquidExample={templateLiquidExample}
      />
    </DeveloperDocsLayout>
  )
}
